export default __webpack_public_path__ + "static/media/etherscan-logo-circle.4fa0af1d.svg";